import type { ReactNode } from 'react';

export type BadgeTone =
  | 'neutral'
  | 'primary'
  | 'accent'
  | 'secondary'
  | 'outline'
  | 'solid';

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-background-200 text-foreground-700 border border-background-300',
  primary: 'bg-primary-100 text-primary-800 border border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-900 border border-secondary-200',
  outline: 'bg-transparent text-foreground-600 border border-background-300',
  solid: 'bg-foreground-900 text-background-50 border border-foreground-900',
};

interface BadgeProps {
  tone?: BadgeTone;
  icon?: string;
  children: ReactNode;
  className?: string;
}

export default function Badge({
  tone = 'neutral',
  icon,
  children,
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-label font-medium whitespace-nowrap ${toneClasses[tone]} ${className}`}
    >
      {icon ? <i className={`${icon} text-[12px]`} /> : null}
      {children}
    </span>
  );
}